import React, { useContext } from "react";
import { cleanJoin } from "../../utils/stringUtil";
import { MessageContext } from "./MessageContext";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import Loader from "../loader/Loader";

// TODO Check whether to automatically close message onYes and onNo
function Message({
  title,
  content,
  show = false,
  yesLabel,
  noLabel,
  onYes,
  onNo,
  hideYes,
  hideNo,
  hideX,
  isWait,
}) {
  const message = useContext(MessageContext);

  return (
    <div style={{ zIndex: "100" }} className={cleanJoin("modal", show ? "is-active" : "")}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="p-4 modal-card-head">
          <p className="modal-card-title p-2">{title}</p>
          <button
            className={hideX === false ? "delete" : "is-hidden"}
            aria-label="close"
            onClick={() => message.toggle({})}
          ></button>
        </header>
        {!isWait && (
          <section
            className={isWait === false ? "modal-card-body" : "is-hidden"}
            dangerouslySetInnerHTML={{ __html: content }}
          ></section>
        )}
        {isWait && (
          <>
            <section className={isWait === true ? "modal-card-body" : "is-hidden"}>
              <p className="modal-card-content p-4 is-size-3 has-text-centered">{content}</p>
              <div className="container is-clipped">
                <Loader icon={faCircleNotch} size={`4x`} />
              </div>
            </section>
            <div className="modal-card-foot py-5"></div>
          </>
        )}

        {(!hideNo || !hideYes) && (
          <div className="modal-card-foot p-2">
            <div className="container has-text-right">
              {!hideNo && (
                <button className="button" onClick={onNo}>
                  {noLabel}
                </button>
              )}
              {!hideYes && (
                <button className="button is-success" onClick={onYes}>
                  {yesLabel}
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Message;
